// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBp4eoSmmk7L_qHPTL_WauCOBL89xTYLHs',
    authDomain: 'loveyourcamper-app.firebaseapp.com',
    databaseURL: 'https://loveyourcamper-app.firebaseio.com',
    projectId: 'loveyourcamper-app',
    storageBucket: 'loveyourcamper-app.appspot.com',
    messagingSenderId: '326618759639'
  },
  googleMapsAPIKey : 'AIzaSyCgSeJo7CTxJFvzGsPUviOAxrFDlL6QEac',
  instagram: {
    clientId: '18bb5dafedd749c0aee4893bcb371baf',
    clientSecret: 'ae740d8c81bf4b2b9a8407b40c3f2618'
  },
  dialogflow: {
    loveyourcamperBot: '84a756f8989a44528ece6af084b5901f'
  }
};



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/environments/environment.ts